<template>
  <div id="app">
    <img id="logo" src="./assets/logo.png"  alt="Logo">
    <h1>
      Discord Server World
    </h1>
    <h2>
      A whole new world of servers!
    </h2>
    <h3>
      Coming soon, follow our Twitter & join our Discord for more!
    </h3>
    <a href="https://twitter.com/DiscordServers_" target="_blank" class="button">
      Twitter
    </a>
    <a href="https://discord.gg/7wfBa7u" target="_blank" class="button">
      Discord
    </a>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Farro&display=swap');

html, body {
  background-color: #5865F2;
  font-family: 'Farro', sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: whitesmoke;
}

#logo {
  width: 500px;
}

h2, h3 {
  font-weight: normal;
}

.button {
  background-color: #0f4c75;
  border-radius: 28px;
  border: 1px solid #0f4c75;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 17px;
  font-weight:bold;
  padding: 10px 30px;
  text-decoration: none;

}
.button:hover {
  background-color: #1b262c;
}
</style>



// WEBPACK FOOTER //
// src/App.vue